import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { Slot } from '../slot';
import { listRootRecipe } from './styles/list-root.styles';
import type { ListRootPropsInterface } from './types/list-root.types';

/**
 * @since 8.14.0
 */
export const ListRoot = forwardRef<HTMLUListElement | HTMLOListElement, ListRootPropsInterface>(
  (props: ListRootPropsInterface, forwardedRef) => {
    const { appearance, asChild = false, className, css: cssProp, ...rest } = props;

    const styles = css(listRootRecipe.raw({ appearance }), cssProp);

    const Component = asChild ? Slot : appearance === 'number' ? 'ol' : 'ul';

    return (
      <Component
        ref={forwardedRef as any}
        data-c11n-component="List.Root"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', 'c11n_list__root', styles, className)}
        {...rest}
      />
    );
  },
);

ListRoot.displayName = 'List.Root';
